export default "/assets/b1c5815670e5d2e5.svg"